/**
 * Tier bundle builder (product page): flavor quantities, tier progress, multi-variant cart add.
 */
(function () {
  function getProductAlpineData(productRoot) {
    if (
      !productRoot ||
      typeof window.Alpine === "undefined" ||
      typeof window.Alpine.$data !== "function"
    ) {
      return null;
    }
    try {
      return window.Alpine.$data(productRoot);
    } catch (e) {
      return null;
    }
  }

  /** Unit selling price in cents (subscription allocation when subscribed). */
  function variantUnitCents(variant, pd) {
    var otp = Number(variant.price) || 0;
    if (!pd || !pd.subscriptionActive) {
      return otp;
    }
    if (typeof pd.getSubscriptionAllocationPrice === "function") {
      var sp = pd.getSubscriptionAllocationPrice(variant.id);
      if (sp != null && !Number.isNaN(sp)) {
        return sp;
      }
    }
    var pct =
      Number(pd.subscriptionDiscountPercent) ||
      Number(pd.subscriptionBlockDiscountPercent) ||
      0;
    if (pct > 0) {
      return Math.round(otp * (1 - pct / 100));
    }
    return otp;
  }

  /** Compare-at / list unit cents before tier discount (for strike-through total). */
  function variantCompareUnitCents(variant, pd) {
    var price = Number(variant.price) || 0;
    var cmpAt =
      variant.compareAt != null ? Number(variant.compareAt) : 0;
    if (!pd || !pd.subscriptionActive) {
      if (cmpAt > price) {
        return cmpAt;
      }
      return price;
    }
    if (typeof pd.getSubscriptionAllocationCompareAt === "function") {
      var ac = pd.getSubscriptionAllocationCompareAt(variant.id);
      if (ac != null && ac > 0) {
        return ac;
      }
    }
    var sub = variantUnitCents(variant, pd);
    if (cmpAt > sub) {
      return cmpAt;
    }
    return sub;
  }

  function modalSectionsBody() {
    if (
      !window.theme ||
      !window.theme.settings ||
      window.theme.settings.cartType !== "modal"
    ) {
      return {};
    }
    return {
      sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
      sections_url: window.location.pathname,
    };
  }

  window.bundleBuilderInit = function (rootEl) {
    var cfgEl = rootEl.querySelector("[data-bundle-config]");
    var cfg = {};
    try {
      cfg = cfgEl && cfgEl.textContent ? JSON.parse(cfgEl.textContent.trim()) : {};
    } catch (e) {
      console.warn("Bundle builder: invalid config JSON", e);
    }

    var variants = cfg.variants || [];
    var tiers = (cfg.tiers || []).slice().sort(function (a, b) {
      return (a.minQty || 0) - (b.minQty || 0);
    });

    var qty = {};
    for (var i = 0; i < variants.length; i++) {
      qty[String(variants[i].id)] = 0;
    }

    return {
      config: cfg,
      tiers: tiers,
      variants: variants,
      quantities: qty,
      adding: false,
      /** Bumped on external theme:product:pricing so tier ladder $/unit re-reads subscription state. */
      pricingRefreshKey: 0,

      get totalQty() {
        var n = 0;
        var k = Object.keys(this.quantities);
        for (var j = 0; j < k.length; j++) {
          n += Number(this.quantities[k[j]]) || 0;
        }
        return n;
      },

      activeTierIndex() {
        var T = this.totalQty;
        var t = this.tiers;
        if (!t.length) return -1;
        var best = -1;
        for (var i = 0; i < t.length; i++) {
          if (T >= (t[i].minQty || 0)) best = i;
        }
        return best;
      },

      progressPercent() {
        var n = this.tiers.length;
        if (n <= 1) return 0;
        var idx = this.activeTierIndex();
        if (idx < 0) return 0;
        return (idx / (n - 1)) * 100;
      },

      /**
       * Accent fill width (% of track), left-aligned — matches space-between milestone positions.
       */
      meterFillWidthPct() {
        var n = this.tiers.length;
        var idx = this.activeTierIndex();
        if (n < 1 || idx < 0) return 0;
        if (n === 1) return 100;
        return (idx / (n - 1)) * 100;
      },

      /**
       * Lowest subscription-aware unit among variants (matches bundle line math),
       * falls back to Liquid basePriceCents when unavailable.
       */
      effectiveBaseUnitCents() {
        void this.pricingRefreshKey;
        var pd = getProductAlpineData(this._productRoot);
        var vars = this.variants;
        if (!vars || vars.length < 1) {
          return Number(this.config.basePriceCents) || 0;
        }
        var best = null;
        for (var i = 0; i < vars.length; i++) {
          var u = variantUnitCents(vars[i], pd);
          if (best === null || u < best) best = u;
        }
        return best != null ? best : Number(this.config.basePriceCents) || 0;
      },

      /** Marketing unit price on tier ladder (lowest effective unit × tier discount). */
      priceCentsForTier(tierIndex) {
        var base = this.effectiveBaseUnitCents();
        var tier = this.tiers[tierIndex];
        if (!tier) return base;
        var d = Number(tier.discountPercent) || 0;
        if (d <= 0) return base;
        return Math.max(0, Math.round(base * (1 - d / 100)));
      },

      formattedPriceForTier(idx) {
        var cents = this.priceCentsForTier(idx);
        if (
          typeof formatMoney === "function" &&
          window.theme &&
          window.theme.moneyFormat
        ) {
          return formatMoney(cents, theme.moneyFormat);
        }
        return (cents / 100).toFixed(2);
      },

      tierPriceLine(idx) {
        var price = this.formattedPriceForTier(idx);
        var suf = this.config.unitSuffix;
        if (suf != null && String(suf).trim() !== "") {
          return price + String(suf);
        }
        return price;
      },

      inc(variantId, maxEach) {
        var k = String(variantId);
        var m = maxEach != null ? maxEach : 20;
        var next = (Number(this.quantities[k]) || 0) + 1;
        if (next > m) next = m;
        this.quantities[k] = next;
        var self = this;
        this.$nextTick(function () {
          self.pushProductPricing();
        });
      },

      dec(variantId) {
        var k = String(variantId);
        var next = (Number(this.quantities[k]) || 0) - 1;
        if (next < 0) next = 0;
        this.quantities[k] = next;
        var self = this;
        this.$nextTick(function () {
          self.pushProductPricing();
        });
      },

      pushProductPricing() {
        var root = this._productRoot;
        if (!root || typeof root.dispatchEvent !== "function") return;
        var pd = getProductAlpineData(root);
        var total = this.totalQty;
        var ti = this.activeTierIndex();
        var disc = 0;
        if (total > 0 && ti >= 0 && this.tiers[ti]) {
          disc = Number(this.tiers[ti].discountPercent) || 0;
        }
        var sub = 0;
        var cmp = 0;
        for (var i = 0; i < this.variants.length; i++) {
          var v = this.variants[i];
          var q = Number(this.quantities[String(v.id)]) || 0;
          if (q < 1) continue;
          var unit = variantUnitCents(v, pd);
          var cmpU = variantCompareUnitCents(v, pd);
          cmp += q * cmpU;
          var discounted =
            disc > 0 ? Math.round(unit * (1 - disc / 100)) : unit;
          sub += q * discounted;
        }
        var detail = {
          bundlePricingActive: total > 0,
          bundleFromBundleBuilder: true,
        };
        if (total > 0) {
          detail.bundleSubtotalCents = sub;
          detail.bundleCompareSubtotalCents = cmp;
          detail.bundleTotalUnits = total;
        }
        root.dispatchEvent(
          new CustomEvent("theme:product:pricing", {
            bubbles: true,
            detail: detail,
          })
        );
      },

      init() {
        var self = this;
        var formSel = cfg.formSelector || 'form[action*="/cart/add"]';
        var root = rootEl.closest("[data-product-root]");
        this._productRoot = root || null;
        if (root && !root._bundleBuilderPricingListen) {
          root._bundleBuilderPricingListen = true;
          root.addEventListener("theme:product:pricing", function (e) {
            var d = (e && e.detail) || {};
            if (d.bundleFromBundleBuilder) {
              return;
            }
            self.pricingRefreshKey++;
            self.$nextTick(function () {
              self.pushProductPricing();
            });
          });
        }
        var form = root ? root.querySelector(formSel) : document.querySelector(formSel);
        if (!form || form._bundleBuilderHook) {
          this.$nextTick(function () {
            self.pushProductPricing();
          });
          return;
        }
        form._bundleBuilderHook = true;
        form.addEventListener(
          "submit",
          function (e) {
            if (self.adding) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return;
            }
            var total = self.totalQty;
            if (total < 1) {
              if (cfg.requireSelection) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var msg =
                  (window.theme &&
                    window.theme.strings &&
                    window.theme.strings.bundleBuilderSelectQty) ||
                  "Select at least one unit.";
                alert(msg);
              }
              return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            self.addBundleToCart(form);
          },
          true
        );
        this.$nextTick(function () {
          self.pushProductPricing();
        });
      },

      addBundleToCart(form) {
        var self = this;
        if (typeof fetchConfigDefaults !== "function") {
          console.error("bundle-builder: fetchConfigDefaults missing");
          return;
        }
        self.adding = true;
        var pd = getProductAlpineData(form.closest("[data-product-root]"));
        var items = [];
        for (var i = 0; i < self.variants.length; i++) {
          var v = self.variants[i];
          var q = Number(self.quantities[String(v.id)]) || 0;
          if (q > 0) {
            var line = { id: v.id, quantity: q };
            if (pd && pd.subscriptionActive) {
              var sid = "";
              if (typeof pd.getSellingPlanIdForVariant === "function") {
                sid = pd.getSellingPlanIdForVariant(v.id);
              }
              if (!sid && pd.subscriptionSellingPlanId) {
                sid = String(pd.subscriptionSellingPlanId);
              }
              if (sid) {
                var num = parseInt(sid, 10);
                line.selling_plan = Number.isNaN(num) ? sid : num;
              }
            }
            items.push(line);
          }
        }
        if (!items.length) {
          self.adding = false;
          return;
        }

        var body = Object.assign({ items: items }, modalSectionsBody());
        var fetchCfg = fetchConfigDefaults("application/javascript");
        fetchCfg.headers["Content-Type"] = "application/json";
        fetchCfg.body = JSON.stringify(body);

        fetch(window.theme.routes.cart_add_url, fetchCfg)
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (out) {
            var data = out.data;
            if (!out.ok || (data && data.status)) {
              var msg =
                (data && (data.description || data.message)) ||
                (window.theme.strings && window.theme.strings.cartError) ||
                "Could not add to cart.";
              alert(msg);
              return;
            }
            var path =
              typeof window.location.pathname === "string"
                ? window.location.pathname
                : "/";
            var sep = path.indexOf("?") >= 0 ? "&" : "?";
            var secUrl =
              path +
              sep +
              "sections=cart-items,cart-footer,cart-item-count,cart-live-region";
            return fetch(secUrl, { credentials: "same-origin" })
              .then(function (r) {
                return r.json();
              })
              .then(function (sections) {
                var wrapped = { sections: sections };
                document.body.dispatchEvent(
                  new CustomEvent("shapes:cart:afteradditem", {
                    bubbles: true,
                    detail: {
                      response: Object.assign({}, data, wrapped),
                      sourceId: form.id || "",
                      bundle: true,
                    },
                  })
                );
                for (var j = 0; j < self.variants.length; j++) {
                  self.quantities[String(self.variants[j].id)] = 0;
                }
                self.$nextTick(function () {
                  self.pushProductPricing();
                });
              });
          })
          .catch(function (err) {
            console.error(err);
          })
          .finally(function () {
            self.adding = false;
          });
      },
    };
  };
})();
